var _foreignObject, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTachanka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("switch", null, _foreignObject || (_foreignObject = /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305 305H45V45h260v23.056l-28 68.766-19.444 33.068L277 204.501l28 68.293z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m305 77.417-13.417 62.437L305 128.812zm-12.347 93.361L305 192.646v-42.681zm-1.091 30.284L305 211.75v50.917z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M277 277H73V73h204v63.821L262.417 170.5l14.583 34z",
    style: {
      fill: "#a62222"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.397 33.285c-.334-1.915-.714-4.085-2.15-6.49-1.52-2.546-3.444-4.074-4.455-4.758a14.8 14.8 0 0 0-6.683-2.446l-.725-.079-.711.164-4.608 1.066-4.189.969-.262.061-19.445 4.498-4.189.969-.24.056-3.64.842-4.189.969.969 4.189 5.025 21.725.969 4.189 4.189-.969 3.64-.842 4.189-.969.24-.056 19.445-4.498 4.189-.969.262-.061 4.608-1.066.539-.125.49-.257a13.26 13.26 0 0 0 4.689-4.097c1.911-2.725 2.218-5.451 2.349-6.615.25-2.216-.045-3.907-.306-5.4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.534 31.617h3.736v22.299h-3.736z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(-13.026 69.386 42.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.394 27.923h19.958v22.299H75.394z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(-13.026 85.354 39.066)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.668 45.591-4.608 1.066-5.025-21.725 4.608-1.066c.962.105 2.831.441 4.74 1.733.411.278 1.959 1.369 3.173 3.402 1.029 1.723 1.295 3.248 1.606 5.025.241 1.382.45 2.576.269 4.18-.119 1.059-.341 2.837-1.597 4.628a8.9 8.9 0 0 1-3.166 2.757",
    style: {
      fill: "#fff"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.474 44.997c-.628-4.919-3.641-7.946-5.259-9.572-1.552-1.559-4.44-4.461-9.211-5.214a14.5 14.5 0 0 0-2.256-.176c-1.681 0-3.363.288-4.999.856l-.858.298-31.407 29.287 21.022 22.543 31.378-29.26.355-.792c1.147-2.557 1.574-5.312 1.235-7.97"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m151.508 54.758-15.157-16.254 3.808-3.551c1.04-.361 2.917-.85 5.174-.494 3.384.534 5.468 2.628 6.833 4 1.447 1.454 3.599 3.616 4.042 7.083.325 2.548-.423 4.618-.892 5.664z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.299 65.892h22.224v3.476h-22.224z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(47.002 121.403 67.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.135 46.829h22.224v19.527h-22.224z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(47.002 133.239 56.586)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M191.049 70.778c-.898-2.008-2.57-5.746-6.764-8.141-2.095-1.196-4.523-1.866-7.024-1.937l-.908-.026-39.992 16.347 11.663 28.532 39.955-16.332.613-.615c1.979-1.983 3.355-4.409 3.98-7.014 1.157-4.821-.586-8.719-1.523-10.814"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m180.728 87.54-8.409-20.572 4.82-1.97c1.101.031 3.029.239 5.013 1.372 2.974 1.699 4.181 4.396 4.971 6.163.837 1.873 2.083 4.657 1.267 8.056-.599 2.497-2.033 4.168-2.843 4.98q-2.408.987-4.819 1.971",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.676 87.256H158.9v3.489h-22.224z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(67.767 147.78 88.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.891 73.018h22.224v19.527h-22.224z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(67.767 162.996 82.78)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M202.428 111.306c-1.847-3.901-5.217-5.949-7.72-6.98l-.787-.324H150.9v30.824h42.992l.764-.303c3.19-1.267 5.691-3.347 7.233-6.018 1.744-3.021 1.741-5.86 1.736-9.455-.002-3.147-.005-5.226-1.197-7.744"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.972 130.526v-22.224h5.098c1.433.59 4.115 1.979 5.471 4.844.78 1.648.782 3.068.785 5.909.004 3.355.006 5.279-1.16 7.3-1.346 2.331-3.533 3.551-5.096 4.172z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.826 117.676h22.224v3.476h-22.224z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(90 156.938 119.414)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.36 109.914h22.224v19H162.36z",
    style: {
      fill: "#fff"
    },
    transform: "rotate(90 173.472 119.414)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.229 152.458 18.549-42.68-5.722 38.444 29.305-24.444-27.708 46.972 23.722 42.396L287 192.948l5.708 38.49-18.479-43.209z",
    style: {
      fill: "#fff"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m282.688 141.938-2.875 19.312 16.458-13.646-13.812 23.003 11.458 20.726-13-9.583 3.625 21.167L277 188.875l-2.139-1.569.167-34.306 1.861-.656z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M276.889 188.844v-36.5h-25.708v3.5h-30.958v-14.261h-62.028v13.25h-31.679l-.781.323a14.3 14.3 0 0 0-3.691 2.226c-1.347 1.124-2.213 2.291-2.678 2.918a14 14 0 0 0-.961 1.464l-.123.182c-.15.173-.43.494-.534.539-.07.011-.289-.019-.395-.032-1.159-.15-2.187-1.165-2.575-1.595l-1.557-1.722-52.929 8.76v51.977l.096.444a5.82 5.82 0 0 0 5.816 4.6h3.839a9 9 0 0 0 1.737-.077 9.9 9.9 0 0 0 2.812-.872c8.374-4.112 13.636-8.75 14.224-9.278 6.254-5.677 9.393-8.526 11.652-10.855a204 204 0 0 0 12.441-14.088l4.673-.054a286 286 0 0 1-.299 2.616s-.699 5.859-1.937 10.338a6.5 6.5 0 0 1-.891 1.945l-3.954 5.575 43.905.166a7.66 7.66 0 0 0 3.79-.813v28.563h62.028v-23.389h32.722v-23.972h-8.964v-5.379h7.2v3.5h25.707zm-145.659 8.72.541-3.692 8.601 3.608zm88.992-12.22h4.675v5.379h-4.675z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158 159.083h-30.639a10 10 0 0 0-2.595 1.561c-.94.786-1.552 1.6-1.989 2.189-.794 1.07-.669 1.188-1.292 1.903-.461.529-1.176 1.35-2.334 1.759-.966.341-1.804.242-2.346.172-2.641-.343-4.508-2.215-5.181-2.958L64.542 171.5v47.917c.033.154.129.495.427.792.472.47 1.083.462 1.198.458h4c.255.018.608.023 1.022-.035 0 0 .778-.11 1.529-.478 8.178-4.016 13.241-8.611 13.241-8.611 6.195-5.623 9.293-8.435 11.458-10.667a199 199 0 0 0 13.425-15.355l11.381-.131a140 140 0 0 1-.722 7.444c-.75 6.035-1.473 8.592-1.805 9.693a42 42 0 0 1-1.251 3.557h36.083c.212.016 1.404.087 2.403-.806 1.118-.998 1.078-2.385 1.069-2.569zm-3.917 41.75c-.315.312-.687.414-1.333.583-1.052.275-1.894.25-1.917.25-1.309-.028-11.072.069-24.528.194l2.056-14.028 26.222 11c.044.307.154 1.352-.5 2.001m101.348-44.24v3.5h-35.264v21h8.98v13.879h-8.869v15.472h28.416v-15.472h-8.963v-13.879h15.7v3.5h17.208v-28zm-49.959-10.76h10.5v88h-10.5zm-43.028 88h38.5v-88h-38.5zm7-73.639h24.5v7h-24.5zm0 17.516h24.5v7h-24.5zm0 17.515h24.5v7h-24.5zm0 17.515h24.5v7h-24.5z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTachanka);
export default __webpack_public_path__ + "static/media/tachanka.bb91097ec73333f8e9c47d054c6a2eb1.svg";
export { ForwardRef as ReactComponent };